import React, { FC, useContext } from 'react';

import { ReactComponent as ImgLogo } from 'img/icone-otimizado.svg';
import styled from 'styled-components';
import { Spacing } from 'styles/theme/Tema';
import { MenuContext } from 'view/section/Menu/Menu';

export const Logo: FC = () => {
  const context = useContext(MenuContext);

  const classe = context.compacto ? "sr-only" : ""

  return <header id="cabecalho" style={{background: 'var(--menu-background)'}}>
    <H1>
      <div>
        <ImgLogoStyled x="0px" y="0px" width="128" height="128" viewBox="0 0 128 128" preserveAspectRatio="none" />
      </div>
      <div className={classe}>
        Acompanhamento de Serviços
      </div>
    </H1>
  </header>;
}

const H1 = styled.h1`
  color: var(--color-text-dark);

  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
`;

const ImgLogoStyled = styled(ImgLogo)`
  margin: ${Spacing.unit/2}px;
  width: 70px;
  height: auto;
`;